module.exports = __webpack_public_path__ + "img/DE02365.9829faf4.png";